import AddAndEditSampleCategoryPage from "../../../../features/admin/sample-categories/add-and-edit-sample-category-page/add-and-edit-sample-category-page";

export default function AddAndEditSampleCategory({
  isEdit,
}: {
  isEdit: boolean;
}) {
  return <AddAndEditSampleCategoryPage isEdit={isEdit} />;
}
